var React = require('react');

function RightArrowPoint (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("polygon",{"points":"95.88787841796875,0 464.7834103427558,279.47900390625 95.88787841796875,558.9569702148438 95.88787841796875,419.22100830078125 281.1058914179339,279.47900390625 95.88787841796875,139.73800659179688 "})));
}

RightArrowPoint.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"558.957px","height":"558.957px","viewBox":"0 0 558.957 558.957","style":{"enableBackground":"new 0 0 558.957 558.957"},"xmlSpace":"preserve"};

module.exports = RightArrowPoint;

RightArrowPoint.default = RightArrowPoint;
